import React from "react";
import {IPacingMessage} from "../interfaces/IPacingMessage";
import AppIcon from "../images/ascend-white.svg";
import ActionButton from "./ActionButton";
import {ButtonTheme} from "../enums/ButtonTheme";

function PhaseMessage(p: IPacingMessage) {
    return (
        <div className={'phase-message'}>
            <div className={'phase-container'}>
                <img src={AppIcon} alt={"AppIcon"}/>
                <div className={'greeting'}>
                    {p.greeting}
                </div>
                <div className={'heading'}>
                    {p.msgHeading}
                </div>
                <div className={'details'}>
                    {p.msgDetails}
                </div>
                <div className={'congratulatory-photo-container'}>
                    <img src="https://ea-recovery-program.s3.us-west-2.amazonaws.com/images/content-imgs/16-congrat.jpg"
                         alt="ascend-content-photo"
                        className="congrats-photo"/>
                </div>

                <div className={'phase-action-area'}>
                    <ActionButton theme={ButtonTheme.LIGHT}
                                  secondaryText={p.secondaryButton}
                                  secondaryOnClicked={p.secondaryButtonAction}
                                  primaryText={p.primaryButton}
                                  primaryOnClicked={p.primaryButtonAction}/>
                </div>
            </div>
        </div>
    )
}

export default PhaseMessage;